<template>
  <div class="col-12">
    <div class="back-to-admin mt-3" @click="backToDashboard">
      <i class="fas fa-chevron-left"></i> <span>คำขอทั้งหมด</span>
    </div>
    <sync-loader v-if="!companyEditor.status" :color="`#b5b5b5`"
                 style="display: flex; justify-content: center; align-items: center; height: 200px;"></sync-loader>
    <admin-editor-card v-else>
      <div class="admin-card-header">
        <div class="admin-card-header-title">
          {{ companyEditor["name-th"] }}
        </div>
        <span class="insideTable" v-if="companyEditor.status === 'pending'">
          <div class="admin-card-header-badge badge badge-pill badge-primary">รอการอนุมัติ</div>
        </span>
        <span class="insideTable" v-else-if="companyEditor.status === 'approve'">
          <div class="admin-card-header-badge badge badge-pill badge-success">อนุมัติ</div>
        </span>
        <span class="insideTable" v-else-if="companyEditor.status === 'reject'">
          <div class="admin-card-header-badge badge badge-pill badge-danger">ไม่อนุมัติ</div>
        </span>
      </div>
      <FormulateForm class="admin-card-padding" v-model="companyEditor">
        <template v-for="(entry, schemaIndex) in Object.entries(formSchema)">
          <template v-if="entry[0] !== 'sectionName'">
            <div
                v-if="formSchema.sectionName[entry[0]]"
                :key="`${schemaIndex}-${entry[0]}Index`"
                class="form-header">
              <i :class="`fas fa-${formSchema.sectionName[entry[0]].icon}`"></i>
              {{ formSchema.sectionName[entry[0]].label }}
              <hr>
            </div>
            <template v-if="entry[0] !== 'companyAddress' && entry[0] !== 'companyContact' && entry[0] !== 'companyOnline'">
              <template v-for="(company, entryIndex) in entry[1]">

                <template v-if="company.name === 'industry_group-otherIndustry'">
                  <custom-formulate-input
                      :class="companyEditor['industry_group-industry'] !== 'industry17' ? 'd-none' : ''"
                      :key="`${schemaIndex}-${entry[0]}Index-${entryIndex}`"
                      :entry="company"
                      :entry-index="schemaIndex"
                      :entry-value="companyEditor[company.name]"
                  />
                </template>

                <template v-else>
                  <custom-formulate-input
                      v-if="company.type === 'image'"
                      :key="`${schemaIndex}-${entry[0]}Index-${entryIndex}`"
                      :entry="company"
                      :entry-index="schemaIndex"
                      :entry-value="companyEditor[company.name]"
                      style="width: 30%"
                  />
                  <custom-formulate-input
                      v-else-if="company.type === 'checkbox'"
                      class="checkbox-detail"
                      :key="`${schemaIndex}-${entry[0]}Index-${entryIndex}`"
                      :entry="company"
                      :entry-index="schemaIndex"
                      :entry-value="companyEditor[company.name]"
                  />
                  <custom-formulate-input
                      v-else
                      :key="`${schemaIndex}-${entry[0]}Index-${entryIndex}`"
                      :entry="company"
                      :entry-index="schemaIndex"
                      :entry-value="companyEditor[company.name]"
                  />
                </template>

              </template>
            </template>
            <template v-else-if="entry[0] === 'companyOnline'">
              <template v-for="(company, entryIndex) in entry[1]">
                <template v-if="company.name === 'isOnline_enable'">
                  <custom-formulate-input
                      :key="`${schemaIndex}-${entry[0]}Index-${entryIndex}`"
                      :entry="company"
                      :entry-index="schemaIndex"
                      :entry-value="companyEditor[company.name]"
                  />
                </template>
                <template v-else-if="company.name !== 'isOnline_enable' && companyEditor['isOnline_enable'] === 'yes'">
                  <custom-formulate-input
                      :key="`${schemaIndex}-${entry[0]}Index-${entryIndex}`"
                      :entry="company"
                      :entry-index="schemaIndex"
                      :entry-value="companyEditor[company.name]"
                  >
                    <template v-for="(child, childIndex) in entry[1][entryIndex].children">
                      <custom-formulate-input
                          class="yes-no"
                          :key="`${schemaIndex}-${entry[0]}Index-${entryIndex}-children-${childIndex}`"
                          :entry="child"
                          :entry-index="schemaIndex"
                          :entry-double-full="width >= 768 && child.type === 'select'"
                          :entry-value="companyEditor[child.name]"
                      />
<!--                      <custom-formulate-input-->
<!--                          v-if="companyEditor[company.name] && !child.name.includes('enable')"-->
<!--                          class="yes-no"-->
<!--                          :key="`${schemaIndex}-${entry[0]}Index-${entryIndex}-children-${childIndex}`"-->
<!--                          :entry="child"-->
<!--                          :entry-index="schemaIndex"-->
<!--                          :entry-double-full="width >= 768 && child.type === 'select'"-->
<!--                          :entry-value="companyEditor[child.name]"-->
<!--                      />-->
                    </template>
                  </custom-formulate-input>
                </template>
              </template>
            </template>
            <template v-else-if="entry[0] === 'companyAddress'">

              <custom-formulate-input
                  :key="`${schemaIndex}-${entry[0]}Index-0`"
                  :entry="entry[1][0]"
                  :entry-index="schemaIndex"
                  :entry-value="companyEditor[entry[1][0].name]"
              />
              <div class="double-wide" :key="`${schemaIndex}-${entry[0]}Index-double`">
                <custom-formulate-input
                    :entry="entry[1][1]"
                    :entry-index="schemaIndex"
                    :entry-value="companyEditor[entry[1][1].name]"
                />

                <template v-if="renderComponent === true && entry[1][2].name === 'address-city'">
                  <custom-formulate-input
                      :key="`${schemaIndex}-${entry[0]}Index-2`"
                      :entry="entry[1][2]"
                      :entry-index="schemaIndex"
                      :entry-value="companyEditor[entry[1][2].name]"
                  />
                </template>
              </div>
              <custom-formulate-input
                  :key="`${schemaIndex}-${entry[0]}Index-3`"
                  :entry="entry[1][3]"
                  :entry-index="schemaIndex"
                  :entry-value="companyEditor[entry[1][3].name]"
              />

            </template>
            <template v-else-if="entry[0] === 'companyContact'">

              <div class="double-wide" :key="`${schemaIndex}-${entry[0]}Index-double-0`">
                <custom-formulate-input
                    :entry="entry[1][0]"
                    :entry-index="schemaIndex"
                    :entry-value="companyEditor[entry[1][0].name]"
                />
                <custom-formulate-input
                    :entry="entry[1][1]"
                    :entry-index="schemaIndex"
                    :entry-value="companyEditor[entry[1][1].name]"
                />
              </div>

              <custom-formulate-input
                  :key="`${schemaIndex}-${entry[0]}Index-2`"
                  :entry="entry[1][2]"
                  :entry-index="schemaIndex"
                  :entry-value="companyEditor[entry[1][2].name]"
              />

              <div class="double-wide" :key="`${schemaIndex}-${entry[0]}Index-double-1`">
                <custom-formulate-input
                    :entry="entry[1][3]"
                    :entry-index="schemaIndex"
                    :entry-value="companyEditor[entry[1][3].name]"
                />
                <custom-formulate-input
                    :entry="entry[1][4]"
                    :entry-index="schemaIndex"
                    :entry-value="companyEditor[entry[1][4].name]"
                />
              </div>

            </template>
          </template>
        </template>
      </FormulateForm>
      <hr>
      <div class="btn-approval-layout">
        <button class="btn btn-modal-component-danger btn-long" v-b-modal.confirmationModalReject>ไม่อนุมัติ</button>
        <button class="btn btn-modal-component-success btn-long" v-b-modal.confirmationModalApprove>อนุมัติ</button>
      </div>
    </admin-editor-card>

    <confirmation-modal
        customId="confirmationModalApprove"
        event-name="confirmationValue"
        @confirmationValue="confirmationValue"
        confirmationType="approve"
        cancelTitle="ย้อนกลับ"
        submitTitle="อนุมัติ"
    />
    <confirmation-modal
        customId="confirmationModalReject"
        event-name="confirmationValue"
        @confirmationValue="confirmationValue"
        confirmationType="reject"
        cancelTitle="ย้อนกลับ"
        submitTitle="ไม่อนุมัติ"
    />
  </div>
</template>

<script>
import SyncLoader from 'vue-spinner/src/SyncLoader'
import confirmationModal from "../../../shared/components/modal/confirmationModal";
import customFormulateInput from "../../../shared/components/customFormulateInput";
import adminEditorCard from "@/components/cards/adminEditorCard";
import dataFormatter from "@/services/dataFormatter";
import {mapGetters} from "vuex";
import moment from "moment";
import formSchema from "@/services/formSchema";
import Vue from 'vue';
import VueFormulate from '@braid/vue-formulate';
import defaultOnline from "@/data/defaultOnline.json";

Vue.use(VueFormulate)

import '@/css/snow.css';
import '@/css/theme.min.css';

export default {
  name: "editor",
  components: {
    confirmationModal,
    adminEditorCard,
    SyncLoader,
    customFormulateInput
  },
  computed: {
    ...mapGetters(["getKmuttToken"]),
    width() {
      return window.innerWidth;
    },
  },
  data() {
    return {
      renderComponent: true,
      companyEditor: {},
      values: {},
      formValues: {},
      citiesProvince: {},
      rawCompany: null,
      companyMeeting: {},
      formDataCompanyMeeting: {},
      assignMeetingCount: 0,
      formSchema: formSchema.companyInfoForm("admin")
    }
  },
  methods: {
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    confirmationValue(value) {
      if (!value.value) {
        return;
      }

      this.commitStatus(this.$route.params.uid, value.type)
    },
    async getCompanyForStaff() {
      await this.$store.dispatch("getCompanyDetailForStaff")

      let companySelected = await this.$store.state.company_all.find(company => {
        return company._id === this.$route.params.uid
      })

      companySelected.updated_at = moment(this.companyEditor.updated_at)
          .format("lll")
          .replace(2020, 2563)
          .replace(2021, 2564)
          .replace(2022, 2565)
          .replace(" เวลา ", " ");

      this.companyEditor = await dataFormatter.companyFormFormatter(companySelected);
      this.companyEditor.status = companySelected.status;
      this.rawCompany = JSON.parse(JSON.stringify(companySelected));
    },
    backToDashboard() {
      this.$emit('change-page', 'all')
    },
    async commitStatus(companyId, status) {
      let formData = new FormData();
      let display = "";
      let brochure = "";
      let dataUpdate = dataFormatter.companyInformation(this.companyEditor)

      console.log('dataUpdate', dataUpdate)

      dataUpdate.dayOne_date = dataUpdate.dayOne_date ? dataUpdate.dayOne_date : '21-03-2022'
      dataUpdate.dayTwo_date = dataUpdate.dayTwo_date ? dataUpdate.dayTwo_date : '22-03-2022'

      if (!this.companyEditor.display.files[0].file.url) {
        display = await new File(
            [this.companyEditor.display.files[0].file],
            this.companyEditor.display.files[0].name
        );
        formData.append("display", display);
      }

      if (!this.companyEditor.brochure.files[0].file.url) {
        brochure = await new File(
            [this.companyEditor.brochure.files[0].file],
            this.companyEditor.brochure.files[0].name
        );
        formData.append("brochure", brochure);
      }

      dataUpdate.status = status
      dataUpdate.id = companyId

      const dayOneMorning = dataUpdate.isOnline_dayOne_morning && dataUpdate.isOnline_dayOne_morning[0]
      const dayOneAfternoon = dataUpdate.isOnline_dayOne_afternoon && dataUpdate.isOnline_dayOne_afternoon[0]
      const dayTwoMorning = dataUpdate.isOnline_dayTwo_morning && dataUpdate.isOnline_dayTwo_morning[0]
      const dayTwoAfternoon = dataUpdate.isOnline_dayTwo_afternoon && dataUpdate.isOnline_dayTwo_afternoon[0]

      const dayOneMorningChecked = dayOneMorning && dayOneMorning["isOnline_dayOne_morning-enable"] === 'yes'
      const dayOneAfternoonChecked = dayOneAfternoon && dayOneAfternoon["isOnline_dayOne_afternoon-enable"] === 'yes'
      const dayTwoMorningChecked = dayTwoMorning && dayTwoMorning["isOnline_dayTwo_morning-enable"] === 'yes'
      const dayTwoAfternoonChecked = dayTwoAfternoon && dayTwoAfternoon["isOnline_dayTwo_afternoon-enable"] === 'yes'

      dataUpdate.meeting_times = [
        {
          checked: dayOneMorningChecked || dayOneAfternoonChecked,
          date: dataUpdate.dayOne_date,
          ranges: {
            morning: {
              checked: dayOneMorningChecked,
              start_time: dayOneMorning && dayOneMorning.start_time,
              end_time: dayOneMorning && dayOneMorning.end_time,
              meeting_link: dayOneMorning && dayOneMorning.meeting_link
            },
            afternoon: {
              checked: dayOneAfternoonChecked,
              start_time: dayOneAfternoon && dayOneAfternoon.start_time,
              end_time: dayOneAfternoon && dayOneAfternoon.end_time,
              meeting_link: dayOneAfternoon && dayOneAfternoon.meeting_link
            }
          }
        },
        {
          checked: dayTwoMorningChecked || dayTwoAfternoonChecked,
          date: dataUpdate.dayTwo_date,
          ranges: {
            morning: {
              checked: dayTwoMorningChecked,
              start_time: dayTwoMorning && dayTwoMorning.start_time,
              end_time: dayTwoMorning && dayTwoMorning.end_time,
              meeting_link: dayTwoMorning && dayTwoMorning.meeting_link
            },
            afternoon: {
              checked: dayTwoAfternoonChecked,
              start_time: dayTwoAfternoon && dayTwoAfternoon.start_time,
              end_time: dayTwoAfternoon && dayTwoAfternoon.end_time,
              meeting_link: dayTwoAfternoon && dayTwoAfternoon.meeting_link
            }
          }
        },
      ]

      dataUpdate.online_meeting = dataUpdate.isOnline_enable === 'yes';

      if (dataUpdate.online_meeting === false) {
        dataUpdate.meeting_times = defaultOnline
      }

      delete dataUpdate.isOnline_enable

      delete dataUpdate.dayOne_date;
      delete dataUpdate.dayTwo_date;

      delete dataUpdate.isOnline_dayOne_morning;
      delete dataUpdate.isOnline_dayOne_afternoon;
      delete dataUpdate.isOnline_dayTwo_morning;
      delete dataUpdate.isOnline_dayTwo_afternoon;

      delete dataUpdate.formData_isOnline_dayOne_morning;
      delete dataUpdate.formData_isOnline_dayOne_afternoon;
      delete dataUpdate.formData_isOnline_dayTwo_morning;
      delete dataUpdate.formData_isOnline_dayTwo_afternoon;

      const register_form = JSON.stringify(dataUpdate)

      formData.append("register_form", register_form);

      await this.$store.dispatch("changeStatusCompany", formData)
          .finally(() => {
            window.location.reload()
          })
    },
  },
  async mounted() {
    await this.getCompanyForStaff()
  },
  watch: {
    companyEditor(newValue, oldValue) {
      if (newValue["address-province"] !== oldValue["address-province"]) {
        this.formSchema.companyAddress.forEach(async (value, index) => {
          if (value.name === "address-city") {
            this.formSchema.companyAddress[index].options = await dataFormatter.citiesFilter(newValue["address-province"]);
          }
        })
        this.forceRerender()
      }

      if (this.companyEditor["industry_group-industry"] !== "industry17") {
        this.companyEditor["industry_group-otherIndustry"] = " ";
      }

      if (newValue["isOnline_dayOne_afternoon"] && newValue["isOnline_dayOne_afternoon"][0]["isOnline_dayOne_afternoon-enable"] === ""){
        this.companyEditor["isOnline_dayOne_afternoon"] = this.companyEditor["formData_isOnline_dayOne_afternoon"]
      }
      if (newValue["isOnline_dayOne_morning"] && newValue["isOnline_dayOne_morning"][0]["isOnline_dayOne_morning-enable"] === ""){
        this.companyEditor["isOnline_dayOne_morning"] = this.companyEditor["formData_isOnline_dayOne_morning"]
      }
      if (newValue["isOnline_dayTwo_afternoon"] && newValue["isOnline_dayTwo_afternoon"][0]["isOnline_dayTwo_afternoon-enable"] === ""){
        this.companyEditor["isOnline_dayTwo_afternoon"]= this.companyEditor["formData_isOnline_dayTwo_afternoon"]
      }
      if (newValue["isOnline_dayTwo_morning"] && newValue["isOnline_dayTwo_morning"][0]["isOnline_dayTwo_morning-enable"] === ""){
        this.companyEditor["isOnline_dayTwo_morning"] = this.companyEditor["formData_isOnline_dayTwo_morning"]
      }
    },
  }
}
</script>

<style scoped>

.btn-long {
  width: 30%;
}

.back-to-admin {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: #C03933;
  width: fit-content;
  cursor: pointer;
  transition: 0.1s;
}

.back-to-admin:hover, .back-to-admin:focus {
  color: #E94244;
}

.back-to-admin span:hover, .back-to-admin span:focus {
  text-decoration: underline;
}

.admin-card-padding {
  padding: 0 75px 0 75px;
}

.admin-card-header {
  background-color: #414042;
  display: flex;
  justify-content: space-between;
}

.admin-card-header-title {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 15px 30px;
}

.admin-card-header-badge {
  font-size: 16px;
  margin: 15px 30px;
}

.login-form {
  padding: 2em;
  border: 1px solid #a8a8a8;
  border-radius: .5em;
  max-width: 500px;
  box-sizing: border-box;
}

.form-header {
  font-style: normal;
  font-size: 20px;
  line-height: 28px;
  margin: 50px 0 30px 0;
  color: #C03933;
}

.login-form::v-deep .formulate-input .formulate-input-element {
  max-width: none;
}

.login-form {
  padding: 2em;
  border: 1px solid #a8a8a8;
  border-radius: .5em;
  max-width: 500px;
  box-sizing: border-box;
}

.form-title {
  margin-top: 0;
}

.login-form::v-deep .formulate-input .formulate-input-element {
  max-width: none;
}

.wrapper-class {

}

.other-industry {
  padding-left: 50px;
  width: 30%;
  margin-top: -20px;
}

.btn-approval-layout {
  display: flex;
  justify-content: space-evenly;
  margin: 20px;
}

.yes-no /deep/.formulate-input-element.formulate-input-element--group.formulate-input-group.element-class {
  display: flex;
}

.yes-no /deep/.formulate-input-group-item.formulate-input.input-class {
  width: 50%;
}

.yes-no.formulate-input {
  margin-bottom: 0.5rem;
}

.checkbox-detail /deep/ .formulate-input-group-item.formulate-input.input-class {
  width: 50%;
}

.checkbox-detail /deep/ .formulate-input-element.formulate-input-element--group.formulate-input-group.element-class {
  display: flex;
  flex-wrap: wrap;
}
</style>
